import { useTranslation } from 'react-i18next';
import { HeaderActionType } from '../../Header/HeaderActionType';
import { WarningDialogResource } from '../Warning/WarningDialog';
import redoPairingDialogResource from './RedoPairingDialogResource.json';

function useRedoPairingDialogResource(): WarningDialogResource {
    const { t } = useTranslation();

    const {
        headerContent,
        imgContent,
        warningTitleContent,
        warningMessageContent,
        warningInfoContent,
        buttons,
    } = redoPairingDialogResource;

    const header = {
        id: headerContent.id,
        text: t(headerContent.translationKey),
        type: HeaderActionType.Close,
    };

    const image = imgContent;

    const warningTitle = {
        id: warningTitleContent.id,
        text: t(warningTitleContent.translationKey),
    };

    const warningMessage = {
        id: warningMessageContent.id,
        text: t(warningMessageContent.translationKey),
    };

    const warningInfo = {
        id: warningInfoContent.id,
        text: t(warningInfoContent.translationKey),
    };

    const buttonLabels = {
        primaryLabel: {
            id: buttons.primary.id,
            label: t(buttons.primary.translationKey),
        },
        secondaryLabel: {
            id: buttons.secondary.id,
            label: t(buttons.secondary.translationKey),
        },
    };

    return {
        header,
        image,
        warningTitle,
        warningMessage,
        warningInfo,
        buttonLabels,
    };
}

export default useRedoPairingDialogResource;
